import { GetterTree } from 'vuex'
import { IStateSelectorModel } from '~/models/components/StateSelector'

const getters: GetterTree<IStateSelectorModel, IStateSelectorModel> = {
  states: ({ states }) => states,
}

export default getters
